var map = {
	"./fs": 12,
	"./fs.json": 12,
	"./fs/etc/passwd": 14,
	"./fs/etc/passwd.json": 14,
	"./fs/usr/guest/day1": 19,
	"./fs/usr/guest/day1.json": 19,
	"./fs/usr/guest/day1a": 20,
	"./fs/usr/guest/day1a.json": 20,
	"./fs/usr/guest/day2": 21,
	"./fs/usr/guest/day2.json": 21,
	"./fs/usr/guest/day2a": 22,
	"./fs/usr/guest/day2a.json": 22,
	"./fs/usr/guest/day3": 23,
	"./fs/usr/guest/day3.json": 23,
	"./fs/usr/guest/day3a": 24,
	"./fs/usr/guest/day3a.json": 24,
	"./fs/usr/guest/day4": 25,
	"./fs/usr/guest/day4.json": 25,
	"./fs/usr/guest/day4a": 26,
	"./fs/usr/guest/day4a.json": 26,
	"./fs/usr/guest/remainder": 27,
	"./fs/usr/guest/remainder.json": 27,
	"./fs/usr/guest/welcome": 28,
	"./fs/usr/guest/welcome.json": 28,
	"./fs/usr/lab20/day4a": 29,
	"./fs/usr/lab20/day4a.json": 29,
	"./fs/usr/lab20/remainder": 30,
	"./fs/usr/lab20/remainder.json": 30,
	"./fs/usr/qubick/win": 31,
	"./fs/usr/qubick/win.json": 31,
	"./fs/usr/root/remainder": 32,
	"./fs/usr/root/remainder.json": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;